import React from 'react';
import { Card, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Project = ({ project }) => {
    const { projimg, title, description, id } = project;
    return (
        <>
            <Col sm={12} md={4} lg={4}>
                <Card>
                    <Card.Img variant="top" height="400px" src={projimg} />
                    <Card.Body>
                        <Card.Title className="text-dark">
                            {title}
                        </Card.Title>
                        <Card.Text className="lh-1 fs-6">
                            {description}
                        </Card.Text>
                        <Link to={`/details/${id}`}>
                            <Button variant="info"
                                className="fw-bold px-5 text-white">
                                VIEW DETAILS
                            </Button>
                        </Link>
                    </Card.Body>
                </Card>
            </Col>
        </>
    );
};

export default Project;